import { render } from "./ProfileInfo.vue?vue&type=template&id=66fe5d60&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=66fe5d60&lang=scss&scoped=true"
import "./ProfileInfo.vue?vue&type=style&index=1&id=66fe5d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fe5d60"]])

export default __exports__